import React from "react"

import Layout from "../components/layout/layout"
import SEO from "../components/seo"
// import LeftLines from "../components/lines/leftLines/leftLines"
// import RightLines from "../components/lines/rightLines/rightLines"
// import MisionVision from "../components/misionVision/misionVision"
// import BanerHome from "../components/banerHome/banerHome"
// import Ubicacion from "../components/ubicacion/ubicacion"
// import Organigrama from "../components/organigrama/organigrama"
import Construccion from "../components/construccion/construccion"
const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <Construccion/>
  </Layout>
)

export default IndexPage
